import { create } from "zustand";

/** Global surface for mutation errors. Before this, every useMutation() call
 * across the app that didn't pass an explicit onError silently swallowed
 * failures (React Query catches the rejection internally) — that was
 * already true for replace/scale/expand, and became directly visible once
 * those calls could fail for a real reason (insufficient escrow balance).
 * Wired once in App.tsx's QueryClient defaultOptions.mutations.onError. */
type State = {
  message: string | null;
  show: (message: string) => void;
  clear: () => void;
};

export const useErrorToastStore = create<State>((set) => ({
  message: null,
  show: (message) => set({ message }),
  clear: () => set({ message: null }),
}));
